import React from "react";
import building from "../../../../resources/images/building.jpg";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <div className="container text-relevant text-justify">
      <h1>{t("about-us")}</h1>
      <div style={{ textAlign: "center" }}>
        <img
          className="img-thumbnail ml-4"
          src={building}
          alt="building"
          style={{ "--aspect-ratio": "1080/526", float: "right" }}
          width="400px"
        />
      </div>
      <p dangerouslySetInnerHTML={{ __html: t("about-us-p1") }}></p>

      <p dangerouslySetInnerHTML={{ __html: t("about-us-p2") }}></p>
      <p dangerouslySetInnerHTML={{ __html: t("about-us-p3") }}></p>
      <p>{t("about-us-p4")}</p>
      <hr />
      <h3>{t("directions")}</h3>
      <div className="card">
        <div className="card-header">
          Chapel Library, {t("mount-zion-bible-church")}
        </div>
        <div className="card-body">
          <div
            dangerouslySetInnerHTML={{
              __html:
                '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3440.720628237945!2d-87.24999078487612!3d30.415667281748725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8890bf30d91c3cc9%3A0x5871dea2c60958ad!2s2603+W+Wright+St%2C+Pensacola%2C+FL+32505%2C+USA!5e0!3m2!1sen!2sco!4v1515726771836" width="100%" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>',
            }}
          />
          <h5 className="card-title">
            2603 West Wright Street Pensacola, Florida 32505 USA
          </h5>
          <p className="card-text">{t("about-us-p5")}</p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
